<div mat-dialog-title style="border-bottom: 1px solid #ddd;">
    Організації
</div>

<mat-dialog-content class="mat-typography" style="max-height: calc(100vh - 96px);padding: 0;">

    <table mat-table [dataSource]="data_source" matSort matSortActive="orders_amount" matSortDirection="desc">

        <ng-container matColumnDef="tenant_id">
            <th mat-header-cell *matHeaderCellDef> ID </th>
            <td mat-cell *matCellDef="let row"> {{row.tenant_id}} </td>
            <th mat-footer-cell *matFooterCellDef colspan="3"> Всього </th>
        </ng-container>

        <ng-container matColumnDef="tenant_name">
            <th mat-header-cell *matHeaderCellDef> Назва </th>
            <td mat-cell *matCellDef="let row"> {{row.tenant_name}} </td>
            <td mat-footer-cell *matFooterCellDef style="display:none;"></td>
        </ng-container>

        <ng-container matColumnDef="user">
            <th mat-header-cell *matHeaderCellDef> Адмін </th>
            <td mat-cell *matCellDef="let row">
                <div class="product-extra product-seller">
                    <img class="product-seller-logo" [src]="row.user_image_url" />
                    <span class="product-seller-name">{{row.user_name}} ({{row.user_email}})</span>
                </div>
            </td>
            <td mat-footer-cell *matFooterCellDef style="display:none;"></td>
        </ng-container>

        <ng-container matColumnDef="users_count">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Юзери </th>
            <td mat-cell *matCellDef="let row"> {{row.users_count}} </td>
            <th mat-footer-cell *matFooterCellDef> {{getTotal('users_count')}} </th>
        </ng-container>

        <ng-container matColumnDef="drones_count">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Дрони </th>
            <td mat-cell *matCellDef="let row"> {{row.drones_count}} </td>
            <th mat-footer-cell *matFooterCellDef> {{getTotal('drones_count')}} </th>
        </ng-container>

        <ng-container matColumnDef="orders_count">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Ордери </th>
            <td mat-cell *matCellDef="let row"> {{row.orders_count}} </td>
            <th mat-footer-cell *matFooterCellDef> {{getTotal('orders_count')}} </th>
        </ng-container>

        <ng-container matColumnDef="orders_amount">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Сума </th>
            <td mat-cell *matCellDef="let row"> {{row.orders_amount|currency}} </td>
            <th mat-footer-cell *matFooterCellDef> {{getTotal('orders_amount')|currency}} </th>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayd_columns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayd_columns;"></tr>
        <tr mat-footer-row *matFooterRowDef="displayd_columns; sticky: true"></tr>
    </table>

</mat-dialog-content>